// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__rU2V6","story":"Video_story___y6gi","icon":"Video_icon__iZAVU","play":"Video_play__Gh9jV"};